module.exports = __webpack_public_path__ + "static/studies-487260146.c116872b.jpg";